import type { MessageButton } from '../types/chat-message';

interface ButtonColorConfig {
  background_color?: string;
  text_color?: string;
  border_color?: string;
}

const parseColorConfig = (value?: string): ButtonColorConfig | null => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const getButtonStyle = (btn: MessageButton, isDisabled: boolean): React.CSSProperties => {
  const colorWeb = parseColorConfig(
    btn.commandVariables?.find(v => v.name === 'color_button_web')?.value
  );
  const colorDisableWeb = parseColorConfig(
    btn.commandVariables?.find(v => v.name === 'color_button_disable_web')?.value
  );

  if (isDisabled && colorDisableWeb) {
    return {
      backgroundColor: colorDisableWeb.background_color,
      color: colorDisableWeb.text_color,
      borderColor: colorDisableWeb.border_color,
      borderStyle: 'solid',
      borderWidth: '1px',
    };
  }


  if (colorWeb) {
    return {
      backgroundColor: isDisabled ? undefined : colorWeb.background_color,
      color: isDisabled ? undefined : colorWeb.text_color,
      borderColor: isDisabled ? undefined : colorWeb.border_color,
      borderStyle: 'solid',
      borderWidth: '1px',
    };
  }

  // if (btn.backgroundColor) {
  //   return {
  //     backgroundColor: btn.backgroundColor,
  //     color: btn.textColor,
  //     borderColor: btn.borderColor,
  //     borderStyle: 'solid',
  //     borderWidth: '1px',
  //   };
  // }

  return {};
};
